import { requestJson } from "./apiClient";

export function listMySessions() {
  return requestJson("/api/auth/sessions");
}

export function revokeMySession(sessionId) {
  return requestJson(`/api/auth/sessions/${sessionId}`, {
    method: "DELETE",
  });
}

export function logoutOtherSessions() {
  return requestJson("/api/auth/sessions/logout-others", {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function getLoginHistory(params = {}) {
  const query = new URLSearchParams();
  if (params.limit) {
    query.set("limit", String(params.limit));
  }

  const suffix = query.toString() ? `?${query}` : "";
  return requestJson(`/api/auth/login-history${suffix}`);
}

export function listAdminUserSessions(userId) {
  return requestJson(`/api/admin/users/${userId}/sessions`);
}

export function revokeAdminUserSession(userId, sessionId) {
  return requestJson(`/api/admin/users/${userId}/sessions/${sessionId}`, {
    method: "DELETE",
  });
}

export function revokeAllAdminUserSessions(userId) {
  return requestJson(`/api/admin/users/${userId}/sessions/revoke-all`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}
